import { render, staticRenderFns } from "./interOrderDetail.vue?vue&type=template&id=3dec0446&scoped=true&"
import script from "./interOrderDetail.vue?vue&type=script&lang=js&"
export * from "./interOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./interOrderDetail.vue?vue&type=style&index=0&id=3dec0446&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec0446",
  null
  
)

export default component.exports